import { IsEnum, IsNotEmpty, IsString } from "class-validator";

export enum IrpfRetentionTypeEnumDto {
    yes = "yes",
    no = "no",
}

export class IrpfRetentionTypeDto {
    @IsEnum(IrpfRetentionTypeEnumDto)
    @IsNotEmpty()
    key!: IrpfRetentionTypeEnumDto;

    @IsString()
    @IsNotEmpty()
    value!: string;
}